import { render } from "./ReporteImagenesPreguntas.vue?vue&type=template&id=673ac111&scoped=true"
import script from "./ReporteImagenesPreguntas.vue?vue&type=script&lang=js"
export * from "./ReporteImagenesPreguntas.vue?vue&type=script&lang=js"

import "./ReporteImagenesPreguntas.vue?vue&type=style&index=0&id=673ac111&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-673ac111"]])

export default __exports__